import React from 'react'
import { Button } from 'antd'
import { Switch, Route, Link } from 'react-router-dom'
import Axios from 'axios'
import { ITrame } from './util'
import { Trame } from './Trame'
import { Trame as TrameV2 } from '../adhocV2/Trame'
import { Trames } from './Trames'

interface AdhocRoutesProps {
  oid: string
  trames: ITrame[]
}

export function AdhocRoutes({ oid, trames: initialTrames }: AdhocRoutesProps) {
  const baseUrl = `/organisations/${oid}/etudesadhoc`
  const [trames, setTrames] = React.useState<ITrame[]>(initialTrames)

  React.useEffect(() => {
    Axios.post(`/api/organisations/${oid}/adhoc_data`, { trames })
  }, [oid, trames])

  return (
    <Switch>
      <Route path={`${baseUrl}/trames/v1/:tid`}>
        <Trame
          baseUrl={baseUrl}
          onSave={(newTrames: ITrame[]) => setTrames(newTrames)}
          trames={trames}
        />
      </Route>
      <Route path={[`${baseUrl}/trames/v2/:tid`, `${baseUrl}/trames/:tid`]}>
        <TrameV2
          baseUrl={baseUrl}
          onSave={(newTrames: ITrame[]) => setTrames(newTrames)}
          trames={trames}
        />
      </Route>
      <Route path={`${baseUrl}/trames`}>
        <b>Trames</b>
        <div style={{ marginTop: 20, marginBottom: 20 }}>
          <Link to={`${baseUrl}/trames/new`}>
            <Button>Ajouter</Button>
          </Link>
        </div>
        <Trames
          trames={trames}
          baseUrl={baseUrl}
          onSave={(newTrames: ITrame[]) => setTrames(newTrames)}
        />
      </Route>
    </Switch>
  )
}
